<template>
  <div>
    <div class="d-flex align-center justify-space-between gap px-4 px-md-6 py-4">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="secondary"
            @click="loadRecords"
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </template>
        <span>Refresh</span>
      </v-tooltip>
      <div class="d-flex align-center gap">
        <v-text-field
          v-model="search"
          placeholder="Search"
          single-line
          hide-details="auto"
          clearable
          outlined
          dense
        >
        </v-text-field>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" @click="filter" v-on="on" :disabled="loading">
              <v-icon>mdi-filter-variant</v-icon>
            </v-btn>
          </template>
          Filter
        </v-tooltip>
      </div>
    </div>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-data-table
        :headers="headersTransaction"
        :items="records"
        :items-per-page="5"
        :search="search"
        :loading="loading"
        loading-text="Loading, please wait a moment"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :hide-default-header="records && records.length == 0 ? true : false"
        :hide-default-footer="records && records.length == 0 ? true : false"
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ setCreatedAtFormat(item.created_at) }}</span>
        </template>
      </v-data-table>
    </v-card-text>

    <TransactionFilter v-if="dialog" :dates="dates" @setCloseModal="closeModal" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import formatDatev2 from "@/helpers/formatDatev2";
import formRules from "@/helpers/formRules";
import { format, sub } from "date-fns";
import TransactionFilter from "@/components/playerDetails/TransactionsFilter";

export default {
  components: { TransactionFilter },
  props: {
    id: {
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    valid: true,
    rules: formRules,
    date_from: format(sub(new Date(), { days: 30 }), "yyyy-MM-dd"),
    date_from_menu: false,
    date_to: format(new Date(), "yyyy-MM-dd"),
    date_to_menu: false,
    dates: {},
    search: "",
    sortBy: "created_at",
    sortDesc: true,
    headersTransaction: [
      // { text: 'ID', align: 'end', value: 'id', },
      { text: "TRANSACTION TYPE", value: "transaction_type" },
      { text: "DESCRIPTION", value: "description" },
      { text: "AMOUNT", value: "amount" },
      { text: "CREATED AT", value: "created_at" },
    ],
  }),
  computed: {
    ...mapState("player_details", ["loading", "records"]),
    lessThanDate() {
      if (this.date_from && this.date_to) {
        if (new Date(this.date_to) < new Date(this.date_from)) {
          return "Must be higher or equal than date from.";
        }
      }

      return true;
    },

    lessThanDate2() {
      if (this.date_from && this.date_to) {
        if (new Date(this.date_from) > new Date(this.date_to)) {
          return "Must be lessthan or equal than date to.";
        }
      }

      return true;
    },

    dateToAvailability() {
      if (this.date_from == "" || this.date_from == null) {
        return true;
      }

      return false;
    },
  },
  created() {
    this.loadRecords();
  },
  methods: {
    ...mapActions("player_details", ["getTransactions"]),
    loadRecords() {
      if (!this.recordsLoading) {
        this.$store.commit("player_details/setRecords", []);

        const formData = new FormData();
        formData.append("id", this.id);
        formData.append("date_from", this.date_from);
        formData.append("date_to", this.date_to);

        const getData = new URLSearchParams(formData);

        this.getTransactions(getData);
      }
    },
    setCreatedAtFormat(date) {
      return formatDatev2(date);
    },
    closeModal(dates_filter) {
      this.dialog = false;

      if (dates_filter.filter_status == "search") {
        this.date_from = dates_filter.filter_date_from;
        this.date_to = dates_filter.filter_date_to;
        this.loadRecords();
      }
    },
    filter() {
      if (!this.loading) {
        this.dates = {
          date_from: this.date_from,
          date_to: this.date_to,
        };
        this.dialog = true;
      }
    },
  },
};
</script>
